import React from 'react'
import './App.css'
import {Routes, Route} from "react-router-dom"
import Auth from "./app/pages/Auth"
import Resualt from "./app/pages/Resualt"
import {ToastContainer} from "react-toastify"

function App() {
    return (

        <section className="layout container">
            <ToastContainer className="my-toast"/>
            <Routes>
                <Route path="/" element={<Auth/>}/>
                <Route path="/resualt" element={<Resualt/>}/>
            </Routes>
        </section>

    )
}

export default App
